import { Poller } from '../common/poller';
export class StatePoller {
    constructor(stateRemoteRepository, onConversationsPolled, onMessagesPolled) {
        this.stateRemoteRepository = stateRemoteRepository;
        this.onConversationsPolled = onConversationsPolled;
        this.onMessagesPolled = onMessagesPolled;
        this.poller = new Poller(() => this.poll());
    }
    async poll() {
        const conversationsAndMessages = await this.stateRemoteRepository.getState();
        this.onConversationsPolled(conversationsAndMessages.conversations);
        this.onMessagesPolled(conversationsAndMessages.messages);
    }
    pollIfStarted() {
        this.poller.pollIfStarted();
    }
    start() {
        this.poller.start();
    }
    stop() {
        this.poller.stop();
    }
}
